import DynamicFeedIcon from "@material-ui/icons/DynamicFeed";
import SocietyTypeList from "./SocietyTypeList";

export default {
  list: SocietyTypeList,
  icon: DynamicFeedIcon,
};
